module.exports = "/_next/static/images/4877b29092f59c9dafbcc524d4a3ed2a-man-looking-at-phone@lg-2x.jpg";